import { ADVISOR_OBJECT_KEY, getAgentID, getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY } from './sessionStorage';
import { getAuthToken } from './auth';
import { UnauthorizedPath } from './components/Common/Products/ProductsRoute';

// wrappers for http requests
// will include user access token by default

export const httpRequest = {
  get,
  post,
  put
}

function getUserDetails(field) {
  const advisorObj = getSessionStorageItem(ADVISOR_OBJECT_KEY);
  return (advisorObj && advisorObj[field]) || '';
}

const request = async (method, url, body = '') => {
  const accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);
  const headers = {
    "Authorization": `Bearer ${getAuthToken()}`,
    "NameID": getUserDetails("nameID"),
    "Role": getUserDetails("role"),
    'X-Session-ID': accountObj && accountObj.sessionId,
  };

  const agentID = getAgentID();
  const UserID = getUserDetails('userID');
  if (agentID) { headers["AgentID"] = agentID; } // Only add if not undefined
  if (method === "POST") { headers["UserID"] = UserID; }
  if (method !== "GET") { headers["Content-Type"] = "application/json"; }

  let options = {
    method,
    headers,
  };

  if (method !== 'GET') {
    options = {
      ...options,
      body: body ? JSON.stringify(body) : ''
    }
  }

  const response = await fetch(url, options);
  return handleResponse(response);
};

function get(url) {
  return request("GET", url);
}

function post(url, body) {
  return request('POST', url, body)
}

function put(url, body) {
  return request('PUT', url, body)
}

// non-exported helpers

const isJsonParsable = (text) => {
  try {
    JSON.parse(text);
  } catch (e) {
    return false;
  }
  return true;
}

function handleResponse(response) {
  const contentType = response.headers.get("content-type");
  if (contentType && contentType.includes("application/pdf")) {
    return response;
  }
  return response.text().then(text => {

    if (!isJsonParsable(text) && !response.ok) {

      checkStatusCode(response);
      return Promise.reject('Invalid response message');
    }

    const data = text && JSON.parse(text);

    if (!response.ok) {
      const error = (data && data.message) || response.statusText;

      checkStatusCode(response);
      return Promise.reject(error);
    }

    return data;
  });
}

function checkStatusCode(response) {
  switch (response.status) {
    case 403:
      window.location.href = '/ns';
      break;
    case 401:
      window.location.href = UnauthorizedPath;
      break;
    default:
      break;
  }
}



// WEBPACK FOOTER //
// ./src/httpRequest.js